import { featureFlags } from "@/config/featureFlags";

import { ApiEndpoints } from "../apiEndpoints";
import { requestApi } from "../apiService";

async function getJwtToken(chatId: string, chatType: string) {
  // Phase-1 minter cutover: flag OFF (default) → legacy Rust `register` minter;
  // flag ON → new Umbra minter in ow2-chat-be. Identical request contract.
  const url = featureFlags.useNewMinter
    ? ApiEndpoints.CONFERENCE_TOKEN_UMBRA
    : ApiEndpoints.CONFERENCE_TOKEN;
  const response = await requestApi({
    url,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: { chat_id: chatId, chat_type: chatType },
  });
  return response.data;
}

export default getJwtToken;
